import 'zone.js/plugins/zone-error';
export const environment = {
  production: true,
  urlPrefix: '',
  hmr: false,
};
